import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn';
import { CollapseCard } from '@totalsoft/rocket-ui';
import DecisionSummaryHeader from './DecisionSummaryHeader';
import DecisionSummaryComponent from './DecisionSummaryComponent';
import WrappedFakeText from 'components/common/WrappedFakeText';

const DecisionSummaryCard = ({ t, decisionSummary, contractGenPermissions, generateContract, onCalculateApproval }) => {
  return (
    <CollapseCard
      icon={AssignmentTurnedIn}
      title={t('Document.Decision.Summary.Title')}
      subheader={<DecisionSummaryHeader decisionSummary={decisionSummary} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      {decisionSummary.loading ? (
        <WrappedFakeText lines={5} />
      ) : (
        <DecisionSummaryComponent
          decisionSummary={decisionSummary}
          contractGenPermissions={contractGenPermissions}
          onGenerateContract={generateContract}
          onCalculateApproval={onCalculateApproval}
        />
      )}
    </CollapseCard>
  );
};

DecisionSummaryCard.propTypes = {
  t: PropTypes.func.isRequired,
  decisionSummary: PropTypes.object.isRequired,
  contractGenPermissions: PropTypes.object.isRequired,
  generateContract: PropTypes.func.isRequired,
  onCalculateApproval: PropTypes.func
};
export default withTranslation()(DecisionSummaryCard);
